module.exports = __webpack_public_path__ + "static/img/4.2532637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/4.png
// module id = CDQ4
// module chunks = 0